export class CleanUpSolutionStateError extends Error {

}
